import { TaxRegistrationDTO, TaxRegistrationStatus } from '@/models'

export const getIsTaxRegistrationPending = (status?: TaxRegistrationDTO['status']) => {
    if (!status) return true

    return status === TaxRegistrationStatus.Started || status === TaxRegistrationStatus.InformationRequested
}

export const getIsTaxRegistrationFinished = (status?: TaxRegistrationDTO['status']) => {
    if (!status) return false

    return status === TaxRegistrationStatus.Complete || status === TaxRegistrationStatus.Cancelled
}
